import { Vector3 } from "three";

export let cameraTransform = {
  tavern: {
    lookAt: null,
    vx: 1.5,
    vy: 4,
    vz: -2,
    cy: -3,
  },
  well: { lookAt: null, vx: 6, vy: 3, vz: 4, cy: -5 },
  statue: {
    lookAt: null,
    vx: -4,
    vy: 3,
    vz: 1.5,
    cy: -3,
  },
  stage: { lookAt: null, vx: 5, vy: 1, vz: 0.5, cy: -4 },
  musician: {
    lookAt: null,
    vx: -1.5,
    vy: 1,
    vz: -6,
    cy: -4.5,
  },
  reader: {
    lookAt: null,
    vx: -6.5,
    vy: 0.5,
    vz: -2.5,
    cy: -4.25,
  },
  boat: { lookAt: null, vx: -20, vy: -5, vz: 40, cy: -5 },
  flag: { lookAt: null, vx: 20, vy: 0, vz: 15, cy: -4 },
  route: { lookAt: null, vx: 0, vy: 0, vz: 20, cy: -5 },
};

export const cameraStart = new Vector3(-2, 7, 32);
